import { DOOR_COST_REPORT_PAGE_TYPE } from 'features/summary-report/suppliers/door-cost/types';
import { CREW_MEMBER_DETAIL_TAB } from 'modules/EBusiness/CrewManagement/CrewMemerProfileDetailPage/constants';
import { lazyImport } from 'routes/helpers';
import { getPath } from 'routes/router-paths';
import { TRoute } from 'routes/types';

export const AppHistoryStorageKey = 'app:tabHistory';

export const publicRoutes: TRoute[] = [
  {
    path: getPath('loginPage'),
    element: lazyImport(() => import('modules/Authentication/LoginPage')),
  },
  {
    path: getPath('keycloakAuthenticationPage'),
    element: lazyImport(
      () => import('modules/Authentication/KeycloakAuthenticationPage')
    ),
  },
];

export const privateRoutes: TRoute[] = [
  {
    path: getPath('portalPage'),
    element: lazyImport(() => import('modules/Miscellaneous/PortalPage')),
    title: 'Portal',
  },

  /** Administrator */
  {
    path: getPath('roleManagementPage'),
    element: lazyImport(
      () => import('modules/Administrator/RoleManagementPage')
    ),
    title: 'Phân quyền',
    pathSegmentTitle: 'Quản trị hệ thống / Phân quyền',
  },
  {
    path: getPath('accountManagementPage'),
    element: lazyImport(
      () => import('modules/Administrator/AccountManagementPage')
    ),
    title: 'Quản lý tài khoản',
  },
  {
    path: getPath('accessControlManagementPage'),
    element: lazyImport(
      () => import('modules/Administrator/AccessControlManagementPage')
    ),
    title: 'Quản lý truy cập',
  },

  /** Summary Reports */
  {
    path: getPath(
      'suppliersDoorCostSummaryReportPage',
      ':reportType' as DOOR_COST_REPORT_PAGE_TYPE
    ),
    element: lazyImport(
      () => import('modules/SummaryReport/SuppliersDoorCostSummaryReportPage')
    ),
    title: 'Báo cáo chi phí door',
  },

  /** E-business */
  {
    path: getPath('containerRepairOrdersPage'),
    element: lazyImport(
      () =>
        import(
          'modules/EBusiness/ContainerManagement/ContainerRepairOrdersPage'
        )
    ),
    title: 'Phiếu sửa container',
  },
  {
    path: getPath('containerRepairOrderDetailPage', ':orderId'),
    element: lazyImport(
      () =>
        import(
          'modules/EBusiness/ContainerManagement/ContainerRepairOrderDetailPage'
        )
    ),
    title: 'Chi tiết phiếu sửa container',
  },
  {
    path: getPath('containerRepairQuotationSheetsPage'),
    element: lazyImport(
      () =>
        import(
          'modules/EBusiness/ContainerManagement/ContainerRepairQuotationSheetsPage'
        )
    ),
  },
  {
    path: getPath('quotationListPage'),
    element: lazyImport(
      () => import('modules/EBusiness/EBL/QuotationListPage')
    ),
    title: 'Quotation',
  },
  {
    path: getPath('quotationDetailPage', ':quotationId'),
    element: lazyImport(
      () => import('modules/EBusiness/EBL/QuotationDetailPage')
    ),
    title: 'Chi tiết Quotation',
  },
  {
    path: getPath('billOfLandingPage'),
    element: lazyImport(
      () => import('modules/EBusiness/EBL/BillOfLandingPage')
    ),
    title: 'Bill of Landing',
  },
  {
    path: getPath('doorCostPage'),
    element: lazyImport(
      () => import('modules/EBusiness/SuppliersManagement/DoorCostListPage')
    ),
    title: 'Chi phí door',
  },
  {
    path: getPath('doorCostDetailPage', ':doorCostId'),
    element: lazyImport(
      () => import('modules/EBusiness/SuppliersManagement/DoorCostDetailPage')
    ),
    title: 'Chi tiết phí door',
  },
  {
    path: getPath('crewMemberProfilesManagementPage'),
    element: lazyImport(
      () =>
        import(
          'modules/EBusiness/CrewManagement/CrewMemberProfilesManagementPage'
        )
    ),
    title: 'Hồ sơ thuyền viên',
  },
  {
    path: getPath('availableCrewMembersListPage'),
    element: lazyImport(
      () =>
        import('modules/EBusiness/CrewManagement/AvailableCrewMembersListPage')
    ),
    title: 'Quản lý thuyền viên đang làm việc',
  },
  {
    path: getPath('onLeaveCrewMembersListPage'),
    element: lazyImport(
      () =>
        import('modules/EBusiness/CrewManagement/OnLeaveCrewMembersListPage')
    ),
    title: 'Quản lý thuyền viên nghỉ phép',
  },
  {
    path: getPath(
      'crewMemberProfileDetailPage',
      ':crewMemberId',
      ':sectionId' as CREW_MEMBER_DETAIL_TAB
    ),
    element: lazyImport(
      () =>
        import('modules/EBusiness/CrewManagement/CrewMemerProfileDetailPage')
    ),
    title: 'Chi tiết hồ sơ thuyền viên',
  },
];

export const routes: TRoute[] = [...publicRoutes, ...privateRoutes];
